"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
var reconciliation_1 = require("../../reconciliation");
var buildASAOperation_1 = require("./buildASAOperation");
var bignumber_js_1 = require("bignumber.js");
var currencies_1 = require("../../currencies");
var account_1 = require("../../account");
var promise_1 = require("../../promise");
var tokens_1 = require("./tokens");
var OperationOrderKey = {
    date: 0
};
function buildAlgorandTokenAccount(_a) {
    var parentAccountId = _a.parentAccountId, token = _a.token, coreAccount = _a.coreAccount, existingTokenAccount = _a.existingTokenAccount, balance = _a.balance;
    return __awaiter(this, void 0, void 0, function () {
        var extractedId, id, getAllOperations, operations, tokenAccount;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    extractedId = (0, tokens_1.extractTokenId)(token.id);
                    id = parentAccountId + "+" + extractedId;
                    getAllOperations = function () { return __awaiter(_this, void 0, void 0, function () {
                        var query, coreOperations, operations;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, coreAccount.queryOperations()];
                                case 1:
                                    query = _a.sent();
                                    return [4 /*yield*/, query.complete()];
                                case 2:
                                    _a.sent();
                                    return [4 /*yield*/, query.addOrder(OperationOrderKey.date, false)];
                                case 3:
                                    _a.sent();
                                    return [4 /*yield*/, query.execute()];
                                case 4:
                                    coreOperations = _a.sent();
                                    return [4 /*yield*/, (0, reconciliation_1.minimalOperationsBuilder)((existingTokenAccount && existingTokenAccount.operations) || [], coreOperations, function (coreOperation) {
                                            return (0, buildASAOperation_1.buildASAOperation)({
                                                coreOperation: coreOperation,
                                                accountId: id,
                                                tokenId: extractedId
                                            });
                                        })];
                                case 5:
                                    operations = _a.sent();
                                    return [2 /*return*/, operations];
                            }
                        });
                    }); };
                    return [4 /*yield*/, getAllOperations()];
                case 1:
                    operations = _b.sent();
                    tokenAccount = {
                        type: "TokenAccount",
                        id: id,
                        parentId: parentAccountId,
                        starred: false,
                        token: token,
                        operationsCount: operations.length,
                        operations: operations,
                        pendingOperations: [],
                        balance: balance,
                        spendableBalance: balance,
                        swapHistory: [],
                        creationDate: operations.length > 0
                            ? operations[operations.length - 1].date
                            : new Date(),
                        balanceHistoryCache: account_1.emptyHistoryCache
                    };
                    return [2 /*return*/, tokenAccount];
            }
        });
    });
}
function algorandBuildTokenAccounts(_a) {
    var currency = _a.currency, coreAccount = _a.coreAccount, accountId = _a.accountId, existingAccount = _a.existingAccount, syncConfig = _a.syncConfig;
    return __awaiter(this, void 0, void 0, function () {
        var _b, blacklistedTokenIds, tokenAccounts, algorandAccount, accountASA, existingAccountByTicker, existingAccountTickers, _c, _d, existingSubAccount, _e, ticker, id;
        var e_1, _f;
        var _this = this;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _b = syncConfig.blacklistedTokenIds, blacklistedTokenIds = _b === void 0 ? [] : _b;
                    if ((0, currencies_1.listTokensForCryptoCurrency)(currency).length === 0)
                        return [2 /*return*/, undefined];
                    tokenAccounts = [];
                    return [4 /*yield*/, coreAccount.asAlgorandAccount()];
                case 1:
                    algorandAccount = _g.sent();
                    return [4 /*yield*/, algorandAccount.getAssetsBalances()];
                case 2:
                    accountASA = _g.sent();
                    existingAccountByTicker = {};
                    existingAccountTickers = [];
                    if (existingAccount && existingAccount.subAccounts) {
                        try {
                            for (_c = __values(existingAccount.subAccounts), _d = _c.next(); !_d.done; _d = _c.next()) {
                                existingSubAccount = _d.value;
                                if (existingSubAccount.type === "TokenAccount") {
                                    _e = existingSubAccount.token, ticker = _e.ticker, id = _e.id;
                                    if (!blacklistedTokenIds.includes(id)) {
                                        existingAccountTickers.push(ticker);
                                        existingAccountByTicker[ticker] = existingSubAccount;
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_f = _c["return"])) _f.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    // filter by token existence
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(3, accountASA, function (asa) { return __awaiter(_this, void 0, void 0, function () {
                            var token, _a, _b, existingTokenAccount, tokenAccount, _c, _d;
                            var _e;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0:
                                        _a = currencies_1.findTokenById;
                                        _b = tokens_1.addPrefixToken;
                                        return [4 /*yield*/, asa.getAssetId()];
                                    case 1:
                                        token = _a.apply(void 0, [_b.apply(void 0, [_f.sent()])]);
                                        if (!(token && !blacklistedTokenIds.includes(token.id))) return [3 /*break*/, 4];
                                        existingTokenAccount = existingAccountByTicker[token.ticker];
                                        _c = buildAlgorandTokenAccount;
                                        _e = {
                                            parentAccountId: accountId,
                                            existingTokenAccount: existingTokenAccount,
                                            token: token,
                                            coreAccount: coreAccount
                                        };
                                        _d = bignumber_js_1.BigNumber.bind;
                                        return [4 /*yield*/, asa.getAmount()];
                                    case 2: return [4 /*yield*/, _c.apply(void 0, [(_e.balance = new (_d.apply(bignumber_js_1.BigNumber, [void 0, _f.sent()]))(),
                                                _e)])];
                                    case 3:
                                        tokenAccount = _f.sent();
                                        if (tokenAccount)
                                            tokenAccounts.push(tokenAccount);
                                        _f.label = 4;
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 3:
                    // filter by token existence
                    _g.sent();
                    // Preserve order of tokenAccounts from the existing token accounts
                    tokenAccounts.sort(function (a, b) {
                        var i = existingAccountTickers.indexOf(a.token.ticker);
                        var j = existingAccountTickers.indexOf(b.token.ticker);
                        if (i === j)
                            return 0;
                        if (i < 0)
                            return 1;
                        if (j < 0)
                            return -1;
                        return i - j;
                    });
                    return [2 /*return*/, tokenAccounts];
            }
        });
    });
}
exports["default"] = algorandBuildTokenAccounts;
//# sourceMappingURL=libcore-buildSubAccounts.js.map